import { type ComponentType, type LazyExoticComponent, lazy } from "react";

/** React.lazy for a module that exports its screen by name (the screens are named exports, not defaults). */
export function lazyRoute<P, K extends string>(
  load: () => Promise<Record<K, ComponentType<P>>>,
  name: K,
): LazyExoticComponent<ComponentType<P>> {
  return lazy(async () => ({ default: (await load())[name] }));
}
